import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id A3709A80-3219-4E83-9D4F-EF74F31EEAAE
 * name shield
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shield.svg
 * tags
 * - Gaming / RPG 
 */
export const ShieldIcon = createSvgIcon(<><path d="M12,1L3,5V11C3,16.55 6.84,21.74 12,23C17.16,21.74 21,16.55 21,11V5L12,1Z" /></>, 'ShieldIcon');
export default ShieldIcon